const scrollDirectionInit = () => {
  let pos = 0;
  let dir = 0;
  let ticking = false;
  window.addEventListener('scroll', () => {
    if(window.scrollY > 0) {
      document.querySelector('.header-section').classList.add('scrolled-down')
      document.querySelector('.navigation-snippet').classList.add('scrolled-down')
    } else {
      document.querySelector('.header-section').classList.remove('scrolled-down')
      document.querySelector('.navigation-snippet').classList.remove('scrolled-down')

    }
    if (!ticking) {
      window.requestAnimationFrame(function () {
        const newDir = scrollY > 0 ? Math.sign(pos - scrollY) : 1;
        if (newDir !== dir) {
          window.dispatchEvent(new CustomEvent('blubolt:scrolldir-change', { detail: { direction: newDir } }))
        }
        dir = newDir;
        pos = scrollY;
        ticking = false;
      });
      ticking = true;
    }
  })
  
  window.dispatchEvent(new CustomEvent('blubolt:scrolldir-change', { detail: { direction: 1 } }))
}

export default scrollDirectionInit;